import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.setupLazyLoading()
  }

  setupLazyLoading() {
    const images = Array.from(this.element.querySelectorAll("img[data-lazy-src]"))
    if (images.length === 0) return

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return
          this.loadLazyImage(entry.target)
          this.observer?.unobserve(entry.target)
        })
      },
      {
        root: this.scrollContainer,
        rootMargin: "200px 0px",
        threshold: 0.01
      }
    )

    images.forEach(image => this.observer.observe(image))
  }

  loadLazyImage(image) {
    const src = image.dataset.lazySrc
    if (!src) return
    image.src = src
    if (image.dataset.lazySrcset) image.srcset = image.dataset.lazySrcset
    if (image.dataset.lazySizes) image.sizes = image.dataset.lazySizes
    image.removeAttribute("data-lazy-src")
    image.removeAttribute("data-lazy-srcset")
    image.removeAttribute("data-lazy-sizes")
  }

  disconnect() {
    this.observer?.disconnect()
  }

  get scrollContainer() {
    return this.element.closest(".modal-body")
  }
}
